export default function replaceShopifyCdnUrl(
    sourceURL: string,
    width?: number,
    height?: number
): string {
    if (!sourceURL) return sourceURL;

    // Replace the Shopify CDN URL with the Bunny CDN URL
    const baseURL = sourceURL.replace(
        'https://cdn.shopify.com/s/files/1',
        'https://maap-product-images.b-cdn.net/'
    );

    if (!width && !height) return baseURL;

    const query = new URLSearchParams();
    if (width) query.append('width', width.toString());
    if (height) query.append('height', height.toString());

    // Shopify URLs already carry a `?v=` param, so join with `&` to avoid a double `?`.
    const separator = baseURL.includes('?') ? '&' : '?';
    return `${baseURL}${separator}${query.toString()}`;
}
